import { Fragment, useState } from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import { ImageOutlined } from '@mui/icons-material';
import { UseFormGetValues } from 'react-hook-form';

import MuiTable from 'components/MuiTable';
import { IEtcRecord } from 'apis/survey/type';

import RowContainer from '../components/RowContainer';
import SectionTitle from '../components/SectionTitle';

interface Props {
  getValues: UseFormGetValues<any>;
}

const Radiologies = ({ getValues }: Props) => {
  const miscellaneous: IEtcRecord[] = getValues('miscellaneous');

  const visibleMisc = (miscellaneous ?? []).filter(item => !item.is_hidden);

  const pickFirstImage = (list: IEtcRecord[]) =>
    list[0]?.pt_miscellaneous_image1 ||
    list[0]?.pt_miscellaneous_image2 ||
    list[0]?.pt_miscellaneous_image3 ||
    list[0]?.pt_miscellaneous_image4 ||
    list[0]?.pt_miscellaneous_image5;

  const [selectedImg, setSelectedImg] = useState<string | undefined>(
    pickFirstImage(visibleMisc)
  );

  const columns = [
    { fieldId: 'pt_miscellaneous_no', label: '번호' },
    { fieldId: 'pt_miscellaneous_item', label: '항목', width: 500 },
    { fieldId: 'pt_miscellaneous_image1', label: '기록지 1' },
    { fieldId: 'pt_miscellaneous_image2', label: '기록지 2' },
    { fieldId: 'pt_miscellaneous_image3', label: '기록지 3' },
    { fieldId: 'pt_miscellaneous_image4', label: '기록지 4' },
    { fieldId: 'pt_miscellaneous_image5', label: '기록지 5' },
  ];

  const ImageButton = ({ src }: { src?: string }) => {
    if (!src) return null;
    const color = src === selectedImg ? 'primary' : 'default';
    const onClick = () => setSelectedImg(src);
    return (
      <IconButton size="small" color={color} onClick={onClick}>
        <ImageOutlined />
      </IconButton>
    );
  };

  const rows = visibleMisc.map(item => ({
    ...item,
    id: item.pt_miscellaneous_no,
    pt_miscellaneous_item: item.pt_miscellaneous_item,
    pt_miscellaneous_image1: <ImageButton src={item.pt_miscellaneous_image1} />,
    pt_miscellaneous_image2: <ImageButton src={item.pt_miscellaneous_image2} />,
    pt_miscellaneous_image3: <ImageButton src={item.pt_miscellaneous_image3} />,
    pt_miscellaneous_image4: <ImageButton src={item.pt_miscellaneous_image4} />,
    pt_miscellaneous_image5: <ImageButton src={item.pt_miscellaneous_image5} />,
  }));

  return (
    <Fragment>
      <SectionTitle title="기타 기록" />

      <RowContainer ratio={12}>
        <Grid item xs={12}>
          <MuiTable columns={columns} rows={rows} />
        </Grid>

        <Grid item xs={12}>
          {selectedImg && (
            <Box
              display="flex"
              justifyContent="center"
              sx={{ backgroundColor: 'lightGrey' }}
            >
              <Box
                component="img"
                src={selectedImg}
                height={450}
                sx={{ objectFit: 'contain' }}
              />
            </Box>
          )}
        </Grid>
      </RowContainer>
    </Fragment>
  );
};

export default Radiologies;
